import { render } from "./EditContractTemplates.vue?vue&type=template&id=54a90728"
import script from "./EditContractTemplates.vue?vue&type=script&lang=js"
export * from "./EditContractTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__